import Vuetable from 'vuetable-2/src/components/Vuetable';
import email from 'vuelidate/src/validators/email';
import Avatar from '@/components/Avatar/Avatar';
import LabelList from '@/components/LabelList';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import Input from '@/components/Input/Input';
import CustomTable from '@/components/Table';
import Pagination from '@/components/Pagination';
import sort from '@/utils/Sort';
import Context from '@/models/Context';
import Group from '@/models/core/Group';
import { mapActions, mapGetters } from 'vuex';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';
import MultiSelectSearch from '../../MultiSelectSearch/MultiSelectSearch';

export default {
  name: 'InviteTable',
  components: {
    Vuetable,
    Avatar,
    LabelList,
    Button,
    Input,
    Modal,
    ToastWrapper,
    MultiSelectSearch,
    Pagination,
    CustomTable
  },
  props: ['invites', 'openModal'],
  data() {
    return {
      reset: false,
      currentPage: 1,
      paginationItems: 10,
      sortOrder: 'asc',
      sortColumn: 'email',
      selectedInvites: [],
      single: {
        item: null,
        candidateText: null
      },
      modal: {
        resend: {
          single: false,
          multiple: false
        },
        delete: {
          single: false,
          multiple: false
        },
        create: false
      },
      newInvites: {
        email: [],
        message: '',
        role: 'publisher',
        groups: []
      },
      columns: [
        { name: 'State', type: 'AvatarText', key: 'email' },
        {
          name: 'Email',
          type: 'MultiLine',
          key: 'email',
          secondary: 'fullName',
          has_sort: true
        },
        { name: 'State', type: 'Default', key: 'state', has_sort: true },
        {
          name: 'Last invite sent on',
          type: 'Default',
          key: 'sentAtString',
          has_sort: true
        }
      ],
      actions: [
        { icon: 'redo', method: this.resendSingle },
        { icon: 'delete', method: this.deleteSingle }
      ],
      disable: []
    };
  },
  watch: {
    openModal: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.modal.create = val;
          this.$emit('resetOpenModal');
        }
      }
    }
  },
  computed: {
    searchGroups() {
      const groups = Group.query()
        .orderBy('name')
        .get()
        .map(group => {
          return { id: group.id, name: `Group: ${group.name}`, type: 'group' };
        });

      const options = [
        {
          groupName: 'Groups',
          groupValues: groups
        }
      ];

      return options;
    },
    paging() {
      const start = (this.currentPage - 1) * this.paginationItems;

      return {
        start: start,
        end: start + this.paginationItems
      };
    },
    sortedInvites() {
      return sort(this.invites, this.sortColumn, this.sortOrder).slice(
        this.paging.start,
        this.paging.end
      );
    },
    iconDirection() {
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down';
    },
    allSelected() {
      return (
        this.selectedInvites.length === this.sortedInvites.length &&
        this.sortedInvites.length
      );
    },
    deleteCandidateText() {
      return this.selectedInvites.length === 1
        ? this.selectedInvites[0].email
        : `${this.selectedInvites.length} invites`;
    },
    isNewValid() {
      let isValid = true;
      this.newInvites.email.map(value => {
        if (!email(value)) {
          isValid = false;
        }
      });
      return this.newInvites.email.length > 0 && isValid;
    },
    isDeleting: function() {
      return this._isDeleting();
    },
    isUpdating: function() {
      return this._isUpdating();
    }
  },
  methods: {
    ...mapActions({
      _newToast: 'toasts/_addToast',
      _inviteRemove: 'entities/invites/remove',
      _inviteResend: 'entities/invites/resend',
      _inviteCreate: 'entities/invites/create'
    }),
    ...mapGetters({
      _isDeleting: 'entities/invites/isDeleting',
      _isUpdating: 'entities/invites/isUpdating'
    }),
    resetPage() {
      this.selectedUsers = [];
      this.reset = true;
    },
    onMultiAction(value) {
      this.selected.push(value);
    },
    sortOn(column) {
      if (column === this.sortColumn) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },
    select(value) {
      if (this.selectedInvites.includes(value)) {
        this.selectedInvites = this.selectedInvites.filter(current => {
          return current !== value;
        });
      } else {
        this.selectedInvites.push(value);
      }
    },
    selectAll() {
      if (this.allSelected) {
        this.selectedInvites = [];
      } else {
        this.sortedInvites.map(member => {
          if (!this.selectedInvites.includes(member)) {
            this.selectedInvites.push(member);
          }
        });
      }
    },
    isSelected(value) {
      return this.selectedInvites.includes(value) ? 'checked' : '';
    },
    closeCreateModal() {
      this.modal.create = false;
      this.newInvites.email = [];
      this.newInvites.message = '';
    },
    resendSingle(value) {
      this.single.candidateText = value.email;
      this.single.item = value;
      this.modal.resend.single = true;
    },
    deleteSingle(value) {
      this.single.candidateText = value.email;
      this.single.item = value;
      this.modal.delete.single = true;
    },
    resendSingleAction() {
      this._inviteResend([this.single.item]).then(() => {
        this.single.candidateText = '';
        this.single.item = null;
        this.modal.resend.single = false;

        this._newToast({
          text: 'Invite has been successfully resend',
          variant: 'good',
          duration: 2000
        });
      });
    },
    resendSelectionAction() {
      this._inviteResend(this.selectedInvites).then(() => {
        this.selectedInvites = [];
        this.modal.resend.multiple = false;

        this._newToast({
          text: 'Invites have been successfully resend',
          variant: 'good',
          duration: 2000
        });
      });
    },
    deleteSingleAction() {
      this._inviteRemove([this.single.item]).then(() => {
        this.single.candidateText = '';
        this.single.item = null;
        this.modal.delete.single = false;

        this._newToast({
          text: 'Invite has been successfully removed',
          variant: 'good',
          duration: 2000
        });
      });
    },
    deleteSelectionAction() {
      this._inviteRemove(this.selectedInvites).then(() => {
        this.modal.delete.multiple = false;

        if (this.allSelected) {
          this.updateCurrentPage(1);
        } else {
          this.selectedInvites = [];
        }

        this._newToast({
          text: 'Invite has been successfully removed',
          variant: 'good',
          duration: 2000
        });
      });
    },
    createAction() {
      this._inviteCreate(this.newInvites).then(() => {
        this.modal.create = false;
        this.newInvites.email = [];
        this.newInvites.message = '';
        this.newInvites.role = 'publisher';
        this.newInvites.groups = [];

        this._newToast({
          text: 'Invites have been created',
          variant: 'good',
          duration: 2000
        });
      });
    },
    updateCurrentPage(currentPage) {
      this.selectedInvites = [];
      this.currentPage = currentPage;
      this.reset = false;
    }
  }
};
